/**
 * Mortgage Calculator
 *
 * You can changes the default values in config
 *
 * DEV:NOTES
 * Please do not do nay changes in the DO NOT DO ANY CHNAGES block
 * Do import in use project specific import here
 * And play with the render layout structure and keep the params
 */

import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { Row, Col, Button, Form } from 'react-bootstrap';
import { filterNumber, numberFormat, pmt } from "./util"
import { defaultValues } from "./config"
// use project specific import here
import {calculateMonthlyPayment} from "../mortgage"

// User project specific const
const durationOptions = [10, 15, 20, 30, 35]

// DO NOT DO ANY CHNAGES - START
const MortgageCalc = props => {
  const {
    propertyPrice,
    depositAmount,
    loadDuration,
    interestRate,
    currency,
    title,
    defaultResult,
    pricePrefix,
    // instantResult,
    // durationSuffix,
    // yearSuffix,
    // yearSelect,
  } = props

    const [monthlyPayment, setMonthlyPayment] = useState(0);

  const prefix = pricePrefix ? currency : ""
  const [validated, setValidated] = useState(false)
  const [showerror, setShowerror] = useState(false)
  const [purchasePrice, setPurchasePrice] = useState(
    prefix + numberFormat(propertyPrice)
  )
  const [deposit, setDeposit] = useState(prefix + numberFormat(depositAmount))
  const [duration, setDuration] = useState(loadDuration)
  const [interest, setInterest] = useState(interestRate)
  const [loan, setLoan] = useState("")
  const [result, setResult] = useState("")

  const handlePrice = event => {
    let val = filterNumber(event.target.value)
    setPurchasePrice(prefix + numberFormat(val))
    if (parseInt(filterNumber(deposit)) && parseInt(val)) {
      let loan = parseInt(val) - parseInt(filterNumber(deposit))
      setLoan(prefix + numberFormat(loan))
    } else {
      setLoan(prefix + 0)
    }
  }

  const handleDeposit = event => {
    let d = filterNumber(event.target.value.replace(/[^\d.]/g, ""))
    setDeposit(prefix + numberFormat(d))

    if (parseInt(filterNumber(purchasePrice)) && parseInt(d)) {
      let loan2 = parseInt(filterNumber(purchasePrice)) - parseInt(d)
      setLoan(prefix + numberFormat(loan2))
    } else {
      setLoan(prefix + 0)
    }
  }

  const handleDuration = event => {
    setDuration(filterNumber(event.target.value))
  }

  const handleInterest = event => {
    setInterest(event.target.value.replace(/[^\d.]/g, ""))
  }

  const handleLoan = event => {
    setLoan(prefix + numberFormat(filterNumber(event.target.value)))
  }

  const getResult = (interest, duration, loan) => {
    let result = -pmt(
      interest / 100 / 12,
      filterNumber(duration) * 12,
      filterNumber(loan),
      0,
      1
    )
    setResult(numberFormat(Math.round(result)))
  }

  const handleSubmit = event => {
    const form = event.currentTarget
    event.preventDefault()
    event.stopPropagation()
    if (form.checkValidity() === false) {
      setShowerror(true)
      setValidated(true)
    } else {

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'Calculator',
        'formType': title,
        'formId': "Mortgage Calculator",
        'formName': "Mortgage Calculator",
        'formLabel': "Mortgage Calculator"
      });
      setShowerror(false)
      setValidated(false)
      if (
        parseInt(filterNumber(purchasePrice)) &&
        parseInt(filterNumber(deposit))
      ) {
        let loan =
          parseInt(filterNumber(purchasePrice)) -
          parseInt(filterNumber(deposit))
        setLoan(prefix + numberFormat(loan))
        getResult(interest, duration, loan)
        
        // console.log('duration',parseInt(filterNumber(purchasePrice)),interest,parseInt(filterNumber(deposit)),duration)

        setMonthlyPayment(
          calculateMonthlyPayment(
            parseInt(filterNumber(purchasePrice)),
            parseFloat(interest),
            parseInt(filterNumber(deposit)),
            duration
          )
        );

        // console.log("duration1",monthlyPayment)

      }
    }
  }

  useEffect(() => {
    if (defaultResult) {
      if (
        parseInt(filterNumber(purchasePrice)) &&
        parseInt(filterNumber(deposit))
      ) {
        let loan =
          parseInt(filterNumber(purchasePrice)) -
          parseInt(filterNumber(deposit))
        setLoan(prefix + numberFormat(loan))
      }
      getResult(interest, duration, loan)
    }
  }, [defaultResult, purchasePrice, deposit, loan, interest, duration, prefix])

  // DO NOT DO ANY CHNAGES - END
  var monthly_payment = Math.round(monthlyPayment);

  return (
    <div className="form mortgate-form">
      {showerror && (
        <div className="alert-error">
          <p>* All fields are required</p>
        </div>
      )}
      <Form
        name="MortgageCalc"
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
      >
        <input type="hidden" name="bot-field" />

      <Row>

        <Col md={6}>
          <Form.Group controlId="purchase_price">
            <div className="custom-float">
              <Form.Label>Property Price</Form.Label>
              <Form.Control 
                required
                type="text"
                name="purchase_price"
                value={purchasePrice}
                placeholder="Purchase Price"
                onChange={handlePrice}
              />
            </div>
          </Form.Group>
        </Col>


        <Col md={6}>
          <Form.Group controlId="deposit">
            <div className="custom-float">
              <Form.Label>Deposit</Form.Label>
              <Form.Control 
                required
                type="text"
                name="deposit_available"
                placeholder="Deposit"
                value={deposit}
                onChange={handleDeposit}
              />
            </div>
          </Form.Group>
        </Col>


        <Col md={6}>
          <Form.Group controlId="interest_rate">
            <div className="custom-float">
              <Form.Label>Annual Interest</Form.Label>
              <Form.Control 
                required
                type="text"
                name="interest_rate"
                value={interest}
                placeholder="Annual Interest (%)"
                onChange={handleInterest}
              />
            </div>
          </Form.Group>
        </Col>


        <Col md={6}>
          <Form.Group controlId="duration">
            <div className="custom-float custom-float--select">
              <Form.Label>Repayment</Form.Label>
              <Form.Control 
                as="select"
                className="form-control"
                required
                name="duration"
                value={duration}
                placeholder="Duration (Years)"
                onChange={handleDuration}
              >
                {durationOptions.map((value, key) => {
                  return (
                    <option value={value} key={key}>
                      {value} Years
                    </option>
                  )
                })}
              </Form.Control>
            </div>
          </Form.Group>
        </Col>


        <Col md={6}>
          <Button className="btn btn-pink" type="submit">
            Calculate
          </Button>
        </Col>
        <Col md={6} className="align-items-center d-flex justify-content-md-end">
          {monthly_payment != 0 && monthly_payment && (
            <div className="monthly-pay">
                <span className="txt d-block">Monthly Repayments</span>
                <strong className="pay d-block">{currency} {numberFormat(monthly_payment)}</strong>
            </div>
        )}
        </Col>


      </Row>
      </Form>
      
    </div>
  )
}

MortgageCalc.defaultProps = {
  propertyPrice: defaultValues.PROPERTY_VALUE,
  depositAmount: defaultValues.DEPOSIT,
  loadDuration: defaultValues.DURATION,
  interestRate: defaultValues.INTEREST,
  currency: process.env.CURRENCY
    ? process.env.CURRENCY
    : defaultValues.CURRENCY,
  defaultResult: defaultValues.DEFAULT_RESULT,
  pricePrefix: defaultValues.PRICE_PREFIX,
  // instantResult: defaultValues.INSTANT_RESULT,
  // durationSuffix: defaultValues.DURATION_SUFFIX,
  // yearSuffix: defaultValues.YEAR_SUFFIX,
  // yearSelect: defaultValues.YEAR_SELECT,
}

MortgageCalc.propTypes = {
  propertyPrice: PropTypes.any,
  depositAmount: PropTypes.any,
  loadDuration: PropTypes.any,
  interestRate: PropTypes.any,
  currency: PropTypes.string,
  defaultResult: PropTypes.any,
  pricePrefix: PropTypes.any,
  // instantResult: PropTypes.any,
  // durationSuffix: PropTypes.any,
  // yearSuffix: PropTypes.any,
  // yearSelect: PropTypes.any
}

export default MortgageCalc
